module.exports = __webpack_public_path__ + "static/media/page1b.8adaa1e6.png";